import React from 'react'
import { InstallAccountRates } from '../listRatesService/InstallAccountRates'

export const InstallUSPSAccountRates = () => {
    return <InstallAccountRates />
}
